import { render, staticRenderFns } from "./ActVersionCreate.vue?vue&type=template&id=184e3ab1&"
import script from "./ActVersionCreate.vue?vue&type=script&lang=js&"
export * from "./ActVersionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports